<ng-content select="[title]"></ng-content>
<div>
  @for (item of socials(); track $index) {
  <a [href]="item.link"
     [attr.aria-label]="item.title">
    @if(item.icon && item.icon.includes('.svg')) {
    <app-svg [use]="item.icon"
             role="presentation"
             width="48"
             height="48"></app-svg>
    } @else if(item.icon) {
    <img [src]="item.icon"
    handleError
         role="presentation"
         width="48"
         height="48">
    }
  </a>
  }
</div>
<ng-content></ng-content>
